const sports = [
  {
    ques: "Where is the Wankhede Stadium located?",
    options: ["Delhi", "Mumbai", "Chennai", "Kolkata"],
    correct: "Mumbai",
  },
  {
    ques: "Who is the all-time leading goal scorer in international football?",
    options: [
      "Lionel Messi",
      "Cristiano Ronaldo",
      "Pelé",
      "Zlatan Ibrahimović",
    ],
    correct: "Cristiano Ronaldo",
  },
  {
    ques: "In which sport would you perform a slam dunk?",
    options: ["Tennis", "Basketball", "Golf", "Swimming"],
    correct: "Basketball",
  },
  {
    ques: "Which country has won the most Olympic gold medals in total?",
    options: ["USA", "China", "Russia", "Germany"],
    correct: "USA",
  },
  {
    ques: "Who won the FIFA Ballon d'Or in 2020?",
    options: [
      "Lionel Messi",
      "Cristiano Ronaldo",
      "Robert Lewandowski",
      "No Winner",
    ],
    correct: "Cancelled (No Winner)",
  },
  {
    ques: "Which city hosted the 2012 Summer Olympics?",
    options: ["Rio de Janeiro", "Tokyo", "London", "Beijing"],
    correct: "London",
  },
  {
    ques: "What is the scoring system called in tennis?",
    options: ["Points", "Goals", "Runs", "Love"],
    correct: "Love",
  },
  {
    ques: "Which country won the Cricket World Cup in 2019?",
    options: ["India", "Australia", "England", "New Zealand"],
    correct: "England",
  },
  {
    ques: "Which country has won the most FIFA World Cup titles?",
    options: ["Brazil", "Germany", "Italy", "Argentina"],
    correct: "Brazil",
  },
  {
    ques: "Who is the most decorated Olympian of all time?",
    options: ["Michael Phelps", "Usain Bolt", "Simone Biles", "Serena Williams"],
    correct: "Michael Phelps",
  }
];

const space = [
  {
    ques: "What is the largest planet in our solar system?",
    options: ["Earth", "Jupiter", "Mars", "Saturn"],
    correct: "Jupiter",
  },
  {
    ques: "Which planet is known as the 'Red Planet'?",
    options: ["Venus", "Mars", "Jupiter", "Saturn"],
    correct: "Mars",
  },
  {
    ques: "What is the name of the closest galaxy to the Milky Way?",
    options: ["Andromeda", "Triangulum", "Messier 87", "Centaurus A"],
    correct: "Andromeda",
  },
  {
    ques: "How many moons does Earth have?",
    options: ["1", "2", "3", "4"],
    correct: "1",
  },
  {
    ques: "What is the name of the first artificial satellite launched into space?",
    options: [
      "Sputnik 1",
      "Explorer 1",
      "Vanguard 1",
      "Hubble Space Telescope",
    ],
    correct: "Sputnik 1",
  },
  {
    ques: "Which planet is known as the 'Morning Star' or 'Evening Star'?",
    options: ["Venus", "Mercury", "Mars", "Jupiter"],
    correct: "Venus",
  },
  {
    ques: "What is the name of the largest moon of Saturn?",
    options: ["Titan", "Enceladus", "Rhea", "Dione"],
    correct: "Titan",
  },
  {
    ques: "Which space agency launched the Hubble Space Telescope?",
    options: ["NASA", "ESA (European Space Agency)", "ROSCOSMOS", "ISRO"],
    correct: "NASA",
  },
  {
    ques: "What is the name of the most famous comet that appears once in about 76 years?",
    options: [
      "Halley's Comet",
      "Comet Hale-Bopp",
      "Comet Neowise",
      "Comet ISON",
    ],
    correct: "Halley's Comet",
  },
  {
    ques: "What is the largest moon of Neptune?",
    options: ["Triton", "Nereid", "Proteus", "Larissa"],
    correct: "Triton",
  },
];

const technology = [
  {
    ques: "Which company developed the first commercially available computer mouse?",
    options: ["IBM", "Microsoft", "Apple", "Xerox"],
    correct: "Xerox",
  },
  {
    ques: "What does the acronym 'HTML' stand for?",
    options: [
      "HyperText Markup Language",
      "High-Level Textual Markup Language",
      "HyperTransfer Markup Language",
      "High-Level Transferable Markup Language",
    ],
    correct: "HyperText Markup Language",
  },
  {
    ques: "Who is the co-founder of Microsoft Corporation?",
    options: ["Bill Gates", "Steve Jobs", "Mark Zuckerberg", "Elon Musk"],
    correct: "Bill Gates",
  },
];

const history = [
  {
    ques: "In which year did World War I begin?",
    options: ["1910", "1914", "1918", "1922"],
    correct: "1914",
  },
  {
    ques: "Who was the first President of the United States?",
    options: [
      "John Adams",
      "George Washington",
      "Thomas Jefferson",
      "James Madison",
    ],
    correct: "George Washington",
  },
  {
    ques: "What ancient wonder was located in Alexandria, Egypt?",
    options: [
      "Hanging Gardens of Babylon",
      "Colossus of Rhodes",
      "Mausoleum at Halicarnassus",
      "Lighthouse of Alexandria",
    ],
    correct: "Lighthouse of Alexandria",
  },
  {
    ques: "Who was the first woman to win a Nobel Prize?",
    options: [
      "Marie Curie",
      "Mother Teresa",
      "Rosalind Franklin",
      "Ada Lovelace",
    ],
    correct: "Marie Curie",
  },
  {
    ques: "Which dynasty ruled ancient China from 221 BC to 206 BC?",
    options: ["Han", "Qin", "Tang", "Ming"],
    correct: "Qin",
  },
  {
    ques: "In which year did Christopher Columbus reach the Americas?",
    options: ["1492", "1512", "1556", "1601"],
    correct: "1492",
  },
  {
    ques: "Who wrote 'The Communist Manifesto'?",
    options: ["Karl Marx", "Friedrich Engels", "Vladimir Lenin", "Mao Zedong"],
    correct: "Karl Marx",
  },
  {
    ques: "What event marked the beginning of the French Revolution?",
    options: [
      "Storming of the Bastille",
      "Battle of Waterloo",
      "Execution of Louis XVI",
      "Reign of Terror",
    ],
    correct: "Storming of the Bastille",
  },
  {
    ques: "Who was the leader of the Indian independence movement against British rule?",
    options: [
      "Mahatma Gandhi",
      "Jawaharlal Nehru",
      "Subhas Chandra Bose",
      "Sardar Patel",
    ],
    correct: "Mahatma Gandhi",
  },
  {
    ques: "Which ancient civilization built the city of Machu Picchu?",
    options: ["Inca", "Maya", "Aztec", "Egyptian"],
    correct: "Inca",
  },
];

const reasoning = [
  {
    ques: "What comes next in the series: 2, 6, 12, 20, ___?",
    options: ["24", "28", "32", "36"],
    correct: "30",
  },
  {
    ques: "If CAT is coded as 312, how is DOG coded?",
    options: ["412", "512", "612", "712"],
    correct: "512",
  },
  {
    ques: "What is the missing number: 5, 12, __, 26, 35?",
    options: ["16", "18", "20", "22"],
    correct: "20",
  },
  {
    ques: "If RED is coded as 27, how is SEA coded?",
    options: ["41", "44", "47", "50"],
    correct: "44",
  },
  {
    ques: "Which figure is the odd one out?",
    options: ["Square", "Circle", "Triangle", "Rectangle"],
    correct: "Circle",
  },
  {
    ques: "If the day after tomorrow is a Sunday, what day is it today?",
    options: ["Monday", "Tuesday", "Wednesday", "Thursday"],
    correct: "Friday",
  },
  {
    ques: "What is the next letter in the series: A, C, E, G, ___?",
    options: ["H", "I", "F", "J"],
    correct: "I",
  },
  {
    ques: "If BOOK is coded as 25114, how is NOTE coded?",
    options: ["7145", "8714", "4517", "5471"],
    correct: "7145",
  },
  {
    ques: "What is the odd one out: Apple, Banana, Orange, Mango?",
    options: ["Banana", "Orange", "Mango", "Apple"],
    correct: "Apple",
  },
  {
    ques: "Complete the analogy: Sun is to Day as Moon is to ___?",
    options: ["Night", "Darkness", "Eclipse", "Stars"],
    correct: "Night",
  },
];

const current_Affairs = [
  {
    ques: "Who is the current Prime Minister of the United Kingdom?",
    options: ["Boris Johnson", "Theresa May", "David Cameron", "Tony Blair"],
    correct: "Boris Johnson",
  },
  {
    ques: "In which year did the COVID-19 pandemic begin?",
    options: ["2018", "2019", "2020", "2021"],
    correct: "2019",
  },
  {
    ques: "Which country recently hosted the G7 Summit?",
    options: ["USA", "Germany", "Canada", "UK"],
    correct: "UK",
  },
  {
    ques: "Who won the Nobel Peace Prize in 2020?",
    options: [
      "Malala Yousafzai",
      "Greta Thunberg",
      "World Food Programme",
      "Abiy Ahmed",
    ],
    correct: "World Food Programme",
  },
  {
    ques: "Which country recently launched the Tianzhou-2 cargo spacecraft?",
    options: ["Russia", "China", "USA", "India"],
    correct: "China",
  },
  {
    ques: "What is the capital city of Afghanistan?",
    options: ["Kabul", "Islamabad", "Tehran", "Baghdad"],
    correct: "Kabul",
  },
  {
    ques: "Who is the current President of France?",
    options: [
      "Emmanuel Macron",
      "François Hollande",
      "Nicolas Sarkozy",
      "Jacques Chirac",
    ],
    correct: "Emmanuel Macron",
  },
  {
    ques: "Which country recently signed the Abraham Accords?",
    options: ["Israel", "Saudi Arabia", "United Arab Emirates", "Qatar"],
    correct: "United Arab Emirates",
  },
  {
    ques: "What is the name of the recently discovered COVID-19 variant?",
    options: ["Delta", "Gamma", "Omicron", "Beta"],
    correct: "Omicron",
  },
  {
    ques: "Who won the 2021 Australian Open Women's Singles title?",
    options: [
      "Serena Williams",
      "Simona Halep",
      "Naomi Osaka",
      "Ashleigh Barty",
    ],
    correct: "Naomi Osaka",
  },
];

export { sports, space, history, reasoning, current_Affairs, technology };
